export default __webpack_public_path__ + "static/media/Ballroll_00224.75c9f00c.png";